import apiFetch from '../../apiFetch'

export default function (paperworkId, signTypeId, token) {
  return apiFetch({
    endPoint: `Dossier/Paperwork/${paperworkId}/GenerateFileToSign/${signTypeId}`,
    method: 'GET',
    token: token
  })
}
